// ── Ragdoll Renderer ── Manages active ragdolls in the scene

import * as THREE from 'three';
import { Ragdoll } from '../gameplay/ragdoll';

const MAX_RAGDOLLS = 10;

export class RagdollRenderer {
  private ragdolls: Ragdoll[] = [];
  private scene: THREE.Scene;

  constructor(scene: THREE.Scene) {
    this.scene = scene;
  }

  /** Spawn a ragdoll from a dying player. */
  spawnRagdoll(
    playerMesh: THREE.Group,
    deathPosition: THREE.Vector3,
    impactDirection: THREE.Vector3,
  ): void {
    // Enforce maximum ragdoll count — remove oldest if exceeded
    while (this.ragdolls.length >= MAX_RAGDOLLS) {
      const oldest = this.ragdolls.shift()!;
      this.scene.remove(oldest.mesh);
      oldest.dispose();
    }

    const ragdoll = new Ragdoll(playerMesh, deathPosition, impactDirection);
    this.ragdolls.push(ragdoll);
    this.scene.add(ragdoll.mesh);
  }

  /** Update all active ragdolls. Remove finished ones. */
  update(dt: number): void {
    for (let i = this.ragdolls.length - 1; i >= 0; i--) {
      const alive = this.ragdolls[i].update(dt);
      if (!alive) {
        const ragdoll = this.ragdolls.splice(i, 1)[0];
        this.scene.remove(ragdoll.mesh);
        ragdoll.dispose();
      }
    }
  }

  /** Remove all ragdolls (round end cleanup). */
  clear(): void {
    for (const ragdoll of this.ragdolls) {
      this.scene.remove(ragdoll.mesh);
      ragdoll.dispose();
    }
    this.ragdolls.length = 0;
  }

  /** Dispose all resources. */
  dispose(): void {
    this.clear();
  }

  /** Get count of active ragdolls (for testing/debugging). */
  get count(): number {
    return this.ragdolls.length;
  }
}
